import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { useAnimate } from "framer-motion";

import colors from "../../constants/colors";

// Assets
import arrow_down from "../../assets/icons/arrow_down.svg";
import blob_proxy from "../../assets/icons/blob_proxy.svg";

function SubNav() {
  const [scope, Animate] = useAnimate();
  const [toggleMenu, settoggleMenu] = useState(false);
  const navigate = useNavigate();

  const InitAnimation = async () => {
    Animate(scope.current, { marginRight: 0 });
    Animate("#border", { scale: 0.75, opacity: 0 }, { duration: 0 });
    Animate("#text", { opacity: 0 });
  };

  const openAnimation = async () => {
    Animate(
      scope.current,
      { marginRight: "30px" },
      { duration: 0.2, ease: "easeOut" }
    );
    Animate(
      "#border",
      { scale: 1, opacity: 1 },
      { duration: 0.2, ease: "easeOut" }
    );
    Animate(
      "#text",
      { opacity: 1 },
      { delay: 0.2, duration: 0.3, ease: "easeOut" }
    );
  };

  const exitAnimation = async () => {
    Animate(
      scope.current,
      { marginRight: 0 },
      { delay: 0.1, duration: 0.2, ease: "backOut" }
    );
    Animate(
      "#border",
      { scale: 0.75, opacity: 0 },
      { delay: 0.1, duration: 0.2, ease: "backOut" }
    );
    Animate("#text", { opacity: 0 }, { duration: 0.2, ease: "backOut" });
  };

  useEffect(() => {
    InitAnimation();
  }, []);

  useEffect(() => {
    if (toggleMenu) {
      openAnimation();
    } else {
      exitAnimation();
    }
  }, [toggleMenu]);

  return (
    <div
      ref={scope}
      css={css`
        position: relative;
        width: 150px;
        display: flex;
        justify-content: center;
        margin-left: 20px;
        margin-right: 0;
      `}
      onMouseLeave={() => {
        settoggleMenu(false);
      }}
    >
      <div
        css={css`
          display: flex;
          align-items: center;
          position: relative;
          z-index: 100;
          cursor: pointer;
          filter: drop-shadow(3px 1px 2px #fff);
        `}
        onMouseEnter={() => {
          settoggleMenu(true);
        }}
      >
        <img
          css={css`
            position: absolute;
            left: -15%;
          `}
          src={blob_proxy}
          alt=""
        />
        <p
          css={css`
            z-index: 100;
            font-weight: 800;
            font-size: 16px;
            color: ${colors.INTERFACE_COLORS_BASALT};
          `}
        >
          Proxy
        </p>
        <img
          css={css`
            margin-left: 8px;
            opacity: 1;
          `}
          src={arrow_down}
          alt=""
        />
      </div>
      {
        <div
          id="container"
          css={css`
            display: flex;
            flex-direction: column;
            align-items: center;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            display: flex;
            * {
              user-select: none;
            }
          `}
        >
          <div
            id="border"
            css={css`
              border: 3px solid ${colors.INTERFACE_COLORS_BASALT};
              border-radius: 16px;
              opacity: 0;
              transform-origin: top;
              display: flex;
              flex-direction: column;
              align-items: center;
              background-color: white;
              width: 100%;
              height: 100%;
              position: absolute;
            `}
          ></div>
          <div
            id="text"
            css={css`
              display: flex;
              flex-direction: column;
              align-items: center;
              gap: 10px;
              margin-bottom: 28px;
              margin-top: 60px;
              z-index: 100;
              opacity: 0;
            `}
          >
            {["Proxy Product", "About", "FAQ"].map((link: string) => {
              return (
                <p
                  key={"sb" + link}
                  css={css`
                    font-weight: 800;
                    font-size: 16px;
                    margin: 0;
                    cursor: pointer;
                    pointer-events: ${toggleMenu ? "default" : "none"};
                  `}
                  onClick={() => {
                    navigate('/')
                  }}
                >
                  {link}
                </p>
              );
            })}
          </div>
        </div>
      }
    </div>
  );
}

export default SubNav;
